/*!

=========================================================
* YCorp - v1.0.0
=========================================================
* Coded by Ecrubit
*/
import React from "react";
import ReactDOM from "react-dom";
import Routes from "routes";
import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'

import "assets/css/nucleo-icons.css";
import "assets/scss/YCorp.scss?v=1.2.0";
import "assets/demo/demo.css";

const getLibrary = (provider) => {
  const library = new Web3Provider(provider, 'any')
  library.pollingInterval = 15000
  return library
}

ReactDOM.render(
  <Web3ReactProvider getLibrary={getLibrary}><Routes /></Web3ReactProvider>,
  document.getElementById("root")
);
